import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const iframeV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Iframe element to v2 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'iframe'>): void => {
    const iframeProps = props;

    if (iframeProps?.style?.label?.color && !iframeProps?.content?.title?.iconColor) {
      const currentColor = iframeProps.style.label.color.color1;
      iframeProps.content = {
        ...iframeProps.content,
        title: {
          ...iframeProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
